import { combineReducers } from 'redux';
import getApplicationReducers from '../common/application/get-application-reducers';

export default combineReducers(getApplicationReducers('media'));
